import { sendGAEvent } from '../utils';

export enum DepositEventsEnum {
  dep_success = 'dep_success',
  dep_failed = 'dep_failed',
}

export interface IDepositSuccessData {
  type: 'ftd' | 'std';
  amount: number | string;
  currency: string;
}

/**
 *
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when a deposit is successful.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `dep_success` and the category is `deposit`.
 * The data object contains the type of deposit, amount, and currency.
 */
export const sendDepositSuccessEvent = (data: IDepositSuccessData) => {
  sendGAEvent(DepositEventsEnum.dep_success, {
    event_category: 'deposit',
    ...data,
  });
};
